<nav class="sidebar-body">
  <a
    [routerLink]="[stateService.getUserState() ? '/home' : '/']"
    class="project-title"
    >BETTER</a
  >
  @if (stateService.getUserState()) {
    <ul class="hospitals">
      <p class="hospitals-title">HOSPITALS</p>
      @for (item of contents(); track item.id) {
        <li
          [ngClass]="{
            'sidebar-hospital-selected': item.id === sidebarState().hospital,
          }"
          class="hospitals-list"
        >
          <a
            class="hospital-name-container"
            [routerLink]="['/hospital-info', item.id]"
            ><div class="hospital-name">{{ item.name }}</div>
          </a>
          @if (
            item.id === sidebarState().hospital && item.dataSets.length > 0
          ) {
            <ul class="datasets-list">
              @for (dataset of item.dataSets; track dataset.id) {
                <li
                  [ngClass]="{
                    'sidebar-dataset-selected':
                      dataset.id === sidebarState().dataSet,
                  }"
                >
                  <a
                    class="sidebar-dataset"
                    [routerLink]="[
                      '/hospital',
                      item.id,
                      'data-set',
                      dataset.id,
                    ]"
                  >
                    <span class="dataset-marker">&bull;</span>
                    {{ dataset.name }}</a
                  >
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>

    <div class="bottom-part">
      <div class="system">
        <p class="system-label">SYSTEM</p>
        @if (
          stateService.getUserState() &&
          stateService.getUserState()?.roles?.includes('Admin')
        ) {
          <button class="bottom-button" (click)="goToAdmin()">
            Admin view
          </button>
        }
        <button class="bottom-button" (click)="handleLogout()">Sign out</button>
      </div>
      <div class="user-info">
        <img
          [src]="stateService.getUserState()?.picture"
          alt="User Avatar"
          class="user-avatar"
        />
        <p class="user-name">{{ stateService.getUserState()?.nickname }}</p>
      </div>
    </div>
  }
</nav>
